const { gsap } = require("gsap/dist/gsap");
const { ScrollTrigger } = require("gsap/dist/ScrollTrigger");

gsap.registerPlugin(ScrollTrigger);

module.exports = {
	init: function () {
		ScrollTrigger.matchMedia({
			// large
			"(min-width: 901px)": function () {
				const bigs = gsap.utils.toArray(".big-parallax");
				const littles = gsap.utils.toArray(".little-parallax");
				const downs = gsap.utils.toArray(".down");
				if (bigs) {
					bigs.forEach((big) => {
						gsap.to(big, {
							scrollTrigger: {
								trigger: big,
								toggleActions: "restart pause reverse pause",
								scrub: 1,
								start: "top center",
								// end: 'top 53%',
							},
							y: -300,
							// rotation: 1,
							// rotate: 1080
						});
					});
				}

				if (littles) {
					littles.forEach((little) => {
						gsap.to(little, {
							scrollTrigger: {
								trigger: little,
								toggleActions: "restart pause reverse pause",
								scrub: true,
								start: "top 80%",
								end: "bottom top",
							},
							y: -50,
						});
					});
				}
				if (downs) {
					downs.forEach((down) => {
						gsap.to(down, {
							scrollTrigger: {
								trigger: down,
								toggleActions: "restart pause reverse pause",
								scrub: true,
								start: "top center",
								// end: 'top 53%',
							},
							y: 50,
							// rotate: 1080
						});
					});
				}
			},
		});
	},
};
